export const state = () => ({
  isOpen: false, // mobile drawer open state
  activeNavItemIndex: null, // desktop drawer open topMenu index
  mainNav: [],
  benefits: [],
  helpNav: null,
  alternates: {},
  contactWidget: null,
});

export const actions = {
  open({ commit }) {
    const { $_gtm } = useNuxtApp();

    $_gtm.push({
      event: 'gaEvent',
      event_name: 'navigation_mobile_unfold',
      navigation: {
        navigation_interaction: 'unfold',
        navigation_item: 'mobile_menu',
        event_category: 'Navigation',
        event_action: 'Mobile Menu',
        event_label: 'unfold',
      },
    });

    commit('OPEN');
  },
  close({ commit }) {
    const { $_gtm } = useNuxtApp();

    $_gtm.push({
      event: 'gaEvent',
      event_name: 'navigation_mobile_fold',
      navigation: {
        navigation_interaction: 'fold',
        navigation_item: 'mobile_menu',
        event_category: 'Navigation',
        event_action: 'Mobile Menu',
        event_label: 'fold',
      },
    });

    commit('CLOSE');
  },
};
export const mutations = {
  INIT(state, mainNav) {
    state.mainNav = mainNav;
    state.loading = false;
  },
  OPEN(state) {
    state.isOpen = true;
  },
  CLOSE(state) {
    state.isOpen = false;
  },
  SET_ACTIVE_NAV_ITEM_INDEX(state, index) {
    state.activeNavItemIndex = index;
  },
  SET_HELP_NAV(state, helpNav) {
    state.helpNav = helpNav;
  },
  SET_BENEFITS_NAV(state, benefits) {
    state.benefits = benefits;
  },
  SET_ALTERNATES(state, alternates) {
    if (alternates.length === 0) {
      const { locales } = useI18n();
      const { $switchLocalePath } = useNuxtApp();

      alternates = locales.value.reduce((acc, cur) => {
        acc[cur.code] = $switchLocalePath(cur.code);

        return acc;
      }, {});
    }
    state.alternates = alternates === null ? {} : alternates;
  },

  SET_CONTACT_WIDGET(state, contactWidget) {
    state.contactWidget = contactWidget;
  },
};

export const getters = {
  mainNav(state) {
    return state.mainNav;
  },
  alternates(state) {
    return state.alternates;
  },
  hasAlternates(state) {
    try {
      return state.alternates && Object.entries(state.alternates).length > 0;
    } catch (e) {
      return false;
    }
  },
};
